import type { TranslationCatalog } from "../TranslationManager";

export const ru: TranslationCatalog = {
  "labels.cardNumber": "Номер карты",
  "labels.expirationDate": "Срок действия",
  "labels.cvc": "Код безопасности",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "ММ / ГГ",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Номер вашей карты недействителен.",
  "errors.invalidExpiryDate": "Срок действия вашей карты недействителен.",
  "errors.invalidCvc": "Код безопасности вашей карты недействителен.",
  "errors.incompleteCardNumber": "Номер вашей карты неполный.",
  "errors.incompleteExpiryDate": "Срок действия вашей карты неполный.",
  "errors.incompleteCvc": "Код безопасности вашей карты неполный.",
  "errors.expiredCard": "Срок действия вашей карты истёк.",
  "aria.cardNumber": "Номер карты",
  "aria.expirationDate": "Срок действия",
  "aria.cvc": "Код безопасности",
  "aria.cardInput": "Данные карты",
};
